export default "__VITE_ASSET__6BCv2LGY__"